import Loader from "../../assets/icons/Logo.svg";

const RootLoading = () => {
  return (
    <div className="flex justify-center items-center min-h-screen">
      <img
        src={Loader}
        alt=""
        className="w-32 md:w-36 animate-ping duration-200"
      />
    </div>
  );
};

export default RootLoading;
